/**
 * The compact dialog shell and footer from the imai-design-system dialog
 * pattern (reference: `src/components/org-chat/skill-customize-dialog.tsx`).
 * Change the shared look here, never per dialog.
 *
 * Button groups: equal inset on all sides = the bottom inset. The shell's
 * `p-2` sets the 8px bottom inset; the footer row adds no padding of its own,
 * so the buttons also sit 8px from the left and right edges, and the shell's
 * `gap-2` (or a `space-y-2` body) puts the same 8px above them.
 */
export const COMPACT_DIALOG_SHELL_CLASS = 'gap-2 rounded-2xl p-2';

/** Plain footer row: secondary or metadata left, actions right. */
export const COMPACT_DIALOG_FOOTER_CLASS =
  'flex items-center justify-between gap-2';

/**
 * Inline field label pinned inside an input (rule #6 of the design system).
 * Decorative: the input carries the accessible name, so render it
 * `aria-hidden`. Add `top-1/2 right-2 -translate-y-1/2` for inputs or
 * `right-2 bottom-2` for textareas.
 */
// Dark fields are lighter than the dialog surface, so the label box goes
// transparent there; the field's right padding already keeps text clear.
export const COMPACT_DIALOG_PILL_LABEL_CLASS =
  'text-muted-foreground bg-background dark:bg-transparent pointer-events-none absolute rounded px-2 py-0.5 text-xs';
